<template>
  <div>
    <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
      <base-dropdown v-if="activeModules.length > 0">
        <base-button
          slot="title"
          type="success"
          class="dropdown-toggle"
          disabled
        >
          Time Keeping Module
        </base-button>
        <!-- <a v-for="profile in activeModules" :key="profile.id" @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)" class="dropdown-item" href="#">{{profile.name}}</a> -->
      </base-dropdown>
    </base-header>

    <div class="container-fluid mt-4">
      <div class="card mb-3">
        <div class="row no-gutters" style="min-height: 56vh; overflow: auto">
          <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
            <div class="card-body">
              <div class="row mr-1">
                <div class="col-md-7">
                  <h3 class="col card-title p-0">Time Keeping Settings</h3>
                  <base-checkbox
                    class="mb-3"
                    v-model="formSettings.is_enabled_time_keep_in_rms"
                    >Enable Time Keeping in RMS</base-checkbox
                  >
                  <base-checkbox
                    class="mb-3"
                    v-model="formSettings.is_enabled_time_keep_in_pos"
                    >Enable Time Keeping in POS</base-checkbox
                  >
                  <base-input
                    label="Default entry log"
                    input-classes="form-control form-control-sm"
                  >
                    <br />
                    <a-radio-group
                      v-model="formSettings.time_entry_log_via"
                      @change="saveSettings"
                    >
                      <a-radio value="TEB" key="TEB"> Fingerprint</a-radio>
                      <a-radio value="TES" key="TES">
                        Username and password</a-radio
                      >
                    </a-radio-group>
                  </base-input>

                  <hr class="my-3" />
                  <fieldset :disabled="showForm">
                    <div class="row">
                      <div class="col-md-8">
                        <h3 class="card-title p-0 mb-3 w-70">
                          Time Entry Types
                        </h3>
                      </div>
                      <div class="col-md-4">
                        <button
                          class="btn btn-sm btn-default float-right mr-3"
                          @click.prevent="showSelected('create')"
                        >
                          + Add Entry Type
                        </button>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <vuetable
                        v-if="tableURL.length > 0"
                        ref="vuetable"
                        :api-url="tableURL"
                        :http-options="httpOptions"
                        :fields="fields"
                        :show-sort-icons="true"
                        :per-page="10"
                        :css="tableCSS.table"
                        pagination-path=""
                        data-path="data"
                        no-data-template="Empty"
                        @vuetable:load-error="onLoadError"
                        @vuetable:pagination-data="onPaginationData"
                      >
                        <template slot="actions" slot-scope="props">
                          <center>
                            <div class="table-button-container">
                              <button
                                id="view"
                                class="btn btn-success btn-sm"
                                @click.prevent="
                                  showSelected('View', props.rowData)
                                "
                              >
                                View
                              </button>

                              <button
                                class="btn btn-warning btn-sm"
                                v-if="props.rowData.is_system != 1"
                                @click.prevent="
                                  showSelected('Edit', props.rowData)
                                "
                              >
                                Edit
                              </button>

                              <a-popconfirm
                                v-if="props.rowData.is_system != 1"
                                title="You are about to delete this record?"
                                @confirm="deleteRow(props.rowData.id)"
                                okText="Delete"
                                cancelText="Cancel"
                              >
                                <a class="btn btn-danger btn-sm text-white"
                                  >Delete</a
                                >
                              </a-popconfirm>
                            </div>
                          </center>
                        </template>
                      </vuetable>
                    </div>

                    <div
                      class="card-footer d-flex justify-content-end bg-transparent"
                    >
                      <div class="pagination ui basic segment grid">
                        <vuetable-pagination
                          ref="pagination"
                          @vuetable-pagination:change-page="onChangePage"
                          :css="tableCSS.pagination"
                        >
                        </vuetable-pagination>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-5 card" v-show="showForm">
                  <div class="card-body">
                    <h6 class="heading-small text-muted mb-4 text-truncate">
                      {{
                        this.action == "create" ? "Add New" : this.action
                      }}
                      Entry Type
                      {{
                        this.selecteDetails.inputName
                          ? " - " + this.selecteDetails.inputName
                          : ""
                      }}
                      <div class="float-right">
                        <a-button
                          type="primary"
                          class="btn float-right mr-0 bg-white text-dark btn-sm"
                          @click.prevent="showForm = false"
                          >{{
                            this.action == "View" ? "Back" : "Cancel"
                          }}</a-button
                        >
                        <a-button
                          type="primary"
                          class="btn btn-primary float-right btn-sm border-sm mr-2"
                          v-if="this.action == 'Edit'"
                          :loading="loading"
                          @click.prevent="update"
                          >Update</a-button
                        >
                        <a-button
                          type="primary"
                          class="btn btn-primary float-right btn-sm border-sm mr-2"
                          v-else-if="this.action == 'create'"
                          :loading="loading"
                          @click.prevent="create"
                          >Save</a-button
                        >
                      </div>
                    </h6>
                    <base-alert v-if="errors.length" type="danger">
                      <b>You have the following error(s):</b>
                      <li v-for="error in errors" :key="error">{{ error }}</li>
                    </base-alert>
                    <form id="form-proper">
                      <fieldset :disabled="this.action == 'View'">
                        <base-input
                          alternative=""
                          label="Name"
                          placeholder=""
                          v-model="selecteDetails.name"
                          input-classes="form-control"
                          required
                        />
                        <base-input
                          alternative=""
                          label="Code"
                          placeholder=""
                          v-model="selecteDetails.code"
                          input-classes="form-control"
                          required
                        />
                        <base-input
                          alternative=""
                          label="Sequence No"
                          type="number"
                          placeholder=""
                          v-model="selecteDetails.sequence_no"
                          input-classes="form-control"
                        />
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import HTTPRequest from "../../controllers/httpRequest.js";
import Vuetable from "vuetable-2/src/components/Vuetable";
import ProfilesTable from "../Tables/PosProfilesTable.vue";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import ValidateField from "../../components/validateFormUtils.js";
import FilterBar from "./../FilterBar";
import secureStorage from "../../controllers/secureStorage";

import { mapState, mapActions, nextTick } from "vuex";
var component_x;
export default {
  data: function () {
    return {
      filterStatus: "",
      componentKey: 0,
      formKey: 0,
      activeModules: [],
      accessRights: [],
      formSettings: {},
      parseConfigurationStatus: false,
      tableURL: "",
      fields: [
        { name: "code", title: "Code" },
        { name: "name", title: "Name" },
        { name: "sequence_no", title: "Sequence No" },
        { name: "status", title: "Status" },
        { name: "__slot:actions", title: "Actions" },
      ],
      httpOptions: {
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Request-Source": "BXI-Web",
          ip: secureStorage.getItem("ipAddress"),
        },
      },
      tableCSS: {
        table: {
          tableClass:
            "table table-sm table-striped table-bordered table-hovered",
          loadingClass: "loading",
        },
        pagination: {
          infoClass: "pull-right",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary btn-sm",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      selecteDetails: {},
      errors: [],
      showForm: false,
      action: null,
      loading: false,
      totalCount: null,
    };
  },
  mounted: async function () {
    component_x = this;
    var categoryId = await HTTPRequest.getRequest(
      this.endPoint + "/system_module_categories?code=TK-001",
      null,
      null
    );
    this.activeModules = await HTTPRequest.getRequest(
      this.endPoint +
        "/system_module_categories/" +
        categoryId[0].id +
        "/enabled_modules",
      null,
      null
    );
    if (this.activeModules.length > 0) {
      var profile = _.snakeCase(this.activeModules[0].name);
      this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
    } else {
      this.setCurrentProfile(null, null);
    }
    await this.getData();
  },
  computed: {
    ...mapState(["currentProfile", "currentApiURL", "endPoint", "parameters"]),
  },
  components: {
    ProfilesTable,
    FilterBar,
    Vuetable,
    VuetablePagination,
    ValidateField,
  },
  methods: {
    ...mapActions(["updateCurrentProfile", "updateParameters"]),
    async setCurrentProfile(profile, id) {
      this.profileId = id;
      var accessRightsRequest = await HTTPRequest.getRequest(
        this.endPoint +
          "users/" +
          secureStorage.getItem("userId") +
          "/access_rights?system_module_id=" +
          id,
        null
      );
      if (_.isEmpty(accessRightsRequest.access_rights) == false) {
        this.accessRights = accessRightsRequest.access_rights[id];
      } else {
        this.accessRights = [];
      }
      await this.updateCurrentProfile(profile);
      await this.parseConfiguration();
      this.parseConfigurationStatus = true;
    },
    async parseConfiguration() {
      var response = await HTTPRequest.getRequest(
        this.endPoint + "/system_settings?module_name=tk",
        null
      );
      if (response.data[0] != undefined) {
        this.formSettings = JSON.parse(response.data[0].settings_json);
      } else {
        this.formSettings = {};
      }
    },

    async saveSettings(status) {
      this.spinning = true;
      var formSettings = this.formSettings;
      var userId = secureStorage.getItem("userId");
      var response;
      response = await HTTPRequest.getRequest(
        this.endPoint + "/system_settings?module_name=tk",
        null
      );
      if (response.data.length == 0) {
        var createParams = {
          module_name: "tk",
          user_id: userId,
          settings_json: JSON.stringify(formSettings),
        };
        await HTTPRequest.postRequest(
          this.endPoint + "/system_settings",
          null,
          createParams
        );
      } else {
        var updateParams = {
          system_setting: {
            module_name: "tk",
            settings_json: JSON.stringify(formSettings),
          },
        };
        await HTTPRequest.putRequest(
          this.endPoint + "/system_settings/" + response.data[0].id,
          null,
          updateParams
        );
      }
      if (status == "pos") {
        this.$notification["success"]({
          message: "Action Succesful",
          description: "Please relogin your pos for changes to take effect.",
        });
      } else {
        this.$notification["success"]({
          message: "Action successful",
          description: "Please refresh page for changes to take effect.",
        });
      }
      this.parseConfiguration();
      this.spinning = false;
    },
    getData: async function () {
      this.tableURL = "";
      let tableURL = `${this.endPoint}/time_entry_types`;

      setTimeout(() => {
        this.tableURL = tableURL;
      }, 200);
    },
    onLoadError: async function (error) {
      console.log(error);
    },

    onPaginationData: async function (paginationData) {
      this.totalCount = paginationData.total;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    showSelected(action, data) {
      this.showForm = true;
      if (action != "create") {
        this.selecteDetails = data;
      } else {
        this.selecteDetails = {
          sequence_no: this.totalCount + 1,
        };
      }
      this.action = action;
    },
    validateForm() {
      this.errors = [];
      this.errors.push(
        ValidateField.charMinAndMax("Code", this.selecteDetails.code, 3, 15)
      );
      this.errors.push(
        ValidateField.charMinAndMax("Name", this.selecteDetails.name, 0, 50)
      );
      this.errors.push(
        ValidateField.required("Name", this.selecteDetails.name)
      );
      this.errors.push(
        ValidateField.required("Code", this.selecteDetails.code)
      );
      this.errors = this._.compact(this.errors);
      return this.errors.length;
    },
    create: async function () {
      this.loading = true;
      if (!this.validateForm()) {
        var entryTypePayload = {
          time_entry_type: {
            code: this.selecteDetails.code,
            name: this.selecteDetails.name,
            sequence_no: this.selecteDetails.sequence_no,
            is_sytem: false,
          },
        };
        var post_request = await HTTPRequest.postRequest(
          this.endPoint + "time_entry_types",
          null,
          entryTypePayload
        );
        if (post_request["error"] == undefined) {
          this.$notification["success"]({
            message: "Success",
            description: "Successfully Created.",
          });
          await this.getData();
          this.showForm = false;
        } else {
          this.errors = post_request["error"].split(",");
        }
      }
      this.loading = false;
    },
    update: async function () {
      this.loading = true;
      if (!this.validateForm()) {
        var entryTypePayload = {
          time_entry_type: {
            code: this.selecteDetails.code,
            name: this.selecteDetails.name,
            sequence_no: this.selecteDetails.sequence_no,
            is_sytem: false,
          },
        };
        var put_request = await HTTPRequest.putRequest(
          this.endPoint + "time_entry_types/" + this.selecteDetails.id,
          null,
          entryTypePayload
        );
        if (put_request["error"] == undefined) {
          this.$notification["success"]({
            message: "Success",
            description: "Successfully updated.",
          });
          await this.getData();
          this.showForm = false;
        } else {
          this.errors = put_request["error"].split(",");
        }
      }
      this.loading = false;
    },
    deleteRow(id) {
      axios({
        method: "delete",
        url: this.endPoint + "time_entry_types" + "/" + id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*",
          "Request-Source": "BXI-Web",
          ip: secureStorage.getItem("ipAddress"),
        },
      })
        .then(function () {
          component_x.$notification["success"]({
            message: "Success",
            description: "Successfully Deleted.",
          });
          component_x.$refs.vuetable.refresh();
        })
        .catch(function () {
          alert("Invalid Credentials");
        });
    },
  },
  watch: {
    "formSettings.is_enabled_time_keep_in_rms": function () {
      if (this.parseConfigurationStatus) this.saveSettings("rms");
    },
    "formSettings.is_enabled_time_keep_in_pos": function () {
      if (this.parseConfigurationStatus) this.saveSettings("pos");
    },
  },
};
</script>

<style></style>